import type { IconData } from '@stacksjs/iconify-core'

export const featuredPlaylist: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464 72H48a32.036 32.036 0 0 0-32 32v304a32.036 32.036 0 0 0 32 32h416a32.036 32.036 0 0 0 32-32V104a32.036 32.036 0 0 0-32-32m0 336H48V104h416l.02 304Z\"/><path fill=\"currentColor\" d=\"M232 184h184v32H232zm-56 72h240v32H176zm0 72h240v32H176zM88.923 144v128.923l99.172-69.42z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default featuredPlaylist
